"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";

export default function CorporateFooter({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const links = content.links || ["Privacy Policy", "Terms of Service", "Status", "Contact"];

  return (
    <footer
      className={`py-12 bg-white text-slate-500 text-xs border-t border-slate-200 transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="space-y-1 text-center md:text-left">
          <h3 className="text-sm font-bold text-slate-900">
            <EditableText
              value={content.companyName || "CORP INC"}
              onChange={(val) => onContentChange?.({ ...content, companyName: val })}
              as="span"
            />
          </h3>
          <p>
            <EditableText
              value={content.copyright || "© 2026 Instacks. All rights reserved."}
              onChange={(val) => onContentChange?.({ ...content, copyright: val })}
              as="span"
            />
          </p>
        </div>

        <div className="flex gap-6">
          {links.map((link: string, idx: number) => (
            <a key={idx} href={`#${link.toLowerCase()}`} className="hover:text-blue-650 transition-colors">
              {link}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
